import Vue from "vue";
import api from "../api/index";
import store from "../store/index";
import config from "../config";
const siteConfig = config[process.env.NODE_ENV];
const defalultLang = config.defalultLang;
import i18n from "../locale/i18n.js";

export const browserTitle = title => {
  let name = i18n.t("unicapsule");
  document.title = title ? `${title} | ${name}` : name;
};

export const objToParams = obj => {
  let str = "";
  for (var key in obj) {
    if (str != "") {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(obj[key]);
  }
  return str;
};

export const renderProviderLink = service => {
  if (service === "google") {
    let clientId = siteConfig.providers.google.clientId;
    let redirecUri = siteConfig.providers.google.url;
    let data = {
      approval_prompt: "auto",
      response_type: "code",
      redirect_uri: redirecUri,
      client_id: clientId,
      scope: "email",
      access_type: "online"
    };
    data = objToParams(data);
    return `https://accounts.google.com/o/oauth2/auth?${data}`;
  }
};

export const genRandomNum = len => {
  return Math.random()
    .toString()
    .slice(-len);
};

export const subString = (str, len, hasDot) => {
  if (str.length > len)
    return hasDot ? str.substring(0, len) + "..." : str.substring(0, len);
  else return str;
};

export const pluck = (array, key) => {
  return array.map(o => o[key]);
};

export const convertUrl = (url, size = "small") => {
  // if (url) {
  //   size = "_" + size;
  //   return url.replace(/(\.[\w\d_-]+)$/i, size + "$1");
  // } else {
  //   return "";
  // }

  return (url += "?x-oss-process=style/size_" + size);
};
export const getFileType = file => {
  if (typeof file == "string") {
    return (
      file
        .split(".")
        .pop()
        .toLocaleLowerCase() || ""
    );
  }
  return (
    file.name
      .split(".")
      .pop()
      .toLocaleLowerCase() || ""
  );
};

export const randomCode = n => {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  for (let i of n) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

String.prototype.gblen = function() {
  let len = 0;
  for (let i = 0; i < this.length; i++) {
    if (this.charCodeAt(i) > 127 || this.charCodeAt(i) == 94) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
};

export const substringAddDot = (str, len, hasDot) => {
  if (!str) return "";
  let strLength = str.length;
  if (strLength > len)
    return hasDot ? str.substring(0, len) + "..." : str.substring(0, len);
  else return str;
};

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
  let value = this.getItem(key);
  return value && JSON.parse(value);
};

export function camelCaseToDash(str) {
  return str
    ? str
        .replace(/[^a-zA-Z0-9]+/g, "-")
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/([0-9])([^0-9])/g, "$1-$2")
        .replace(/([^0-9])([0-9])/g, "$1-$2")
        .replace(/-+/g, "-")
        .toLowerCase()
    : "";
}

export const validator = {
  username: /^[A-Za-z0-9_._\u4e00-\u9fa5_\。_\、_\@]+$/,
  email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  url: /^\S*$/,
  link: /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  htmlGeneric: /<[a-z][\s\S]*>/,
  htmlStrict: /<[a-z/][\s\S]*>/
};
